export interface Product {
  id: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export enum ProductSortField {
  CREATED_AT = 'createdAt',
  NAME = 'name',
  UPDATED_AT = 'updatedAt'
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc'
}

export interface GetProductsParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: ProductSortField;
  sortOrder?: SortOrder;
}

export interface PaginationInfo {
  total: number;
  pages: number;
  currentPage: number;
  limit: number;
}

export interface GetProductsResponse {
  success: boolean;
  message: string;
  data: {
    products: Product[];
    pagination: PaginationInfo;
  };
}

export interface CreateProductRequest {
  name: string;
  description: string;
}

export interface CreateProductResponse {
  success: boolean;
  message: string;
  data: {
    product: Product;
  };
}

export interface UpdateProductRequest {
  name: string;
  description: string;
}

export interface UpdateProductResponse {
  success: boolean;
  message: string;
  data: {
    product: Product;
  };
}

export interface DeleteProductResponse {
  success: boolean;
  message: string;
  data: {
    product: Product;
  };
}

export interface ApiErrorResponse {
  success: false;
  message: string;
} 